import { render, staticRenderFns } from "./ExtendedArticle.vue?vue&type=template&id=4bc2abe8&scoped=true&"
import script from "./ExtendedArticle.vue?vue&type=script&lang=js&"
export * from "./ExtendedArticle.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedArticle.vue?vue&type=style&index=0&id=4bc2abe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc2abe8",
  null
  
)

export default component.exports